import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const ReturnsFlagKey = {
  ENABLE_MODALLESS_PORTAL: featureFlagKey("enable-modalless-portal"), // Gate the modalless customer portal experience. Default OFF.
  INSPECT_BEFORE_REFUND: featureFlagKey("inspect-before-refund"), // Reorder processing to inspect/restock items before issuing refund
  MANAGED_RETURNS_TRIAL_ONBOARDING: featureFlagKey(
    "managed-returns-trial-onboarding",
  ), // Gate the Managed Returns trial onboarding to targeted merchant admins
  AUTO_SUBMIT_CLAIMS: featureFlagKey("auto-submit-claims"), // Auto Submit Claims; evaluated per submission method (method attribute in context)
  RETURN_PROCESSING_FLOWS: featureFlagKey("return-processing-flows"), // Enable advanced flow editor for return processing (replaces return/claim processing automations)
  COMPENSATION_AND_RESTOCKING_FLOWS: featureFlagKey(
    "compensation-and-restocking-flows",
  ), // Dark launch: run Compensation and Restocking flows alongside Return Processing Flows on return-ready triggers
  ZIP_CODE_FRAUD: featureFlagKey("zip-code-fraud"), // Enable ZIP-code-based return fraud review in the merchant app
  LIQUIDONATE_DONATION_ROUTING: featureFlagKey("liquidonate-donation-routing"), // Enable Liquidonate donation routing option in the location flow editor
  INTERNATIONAL_RETURNS_READINESS: featureFlagKey(
    "international-returns-readiness",
  ), // Gate the intl-returns customs-readiness RPC/alert/banner. Default OFF.
  NEW_CREATE_SHOPIFY_EXCHANGE_ORDER: featureFlagKey(
    "new-create-shopify-exchange-order",
  ), // ON routes to new createShopifyExchangeOrder; OFF keeps legacy _createExchangeOrder. Per team, default OFF.
  SHOPIFY_RETURNS: featureFlagKey("shopify-returns"), // Shopify return lifecycle for exchange-API returns; per team, default "old".
  SHOPIFY_RETURNS_RETURNABLE_QUANTITY: featureFlagKey(
    "shopify-returns-returnable-quantity",
  ), // When ON, use non-Redo Shopify returns instead of refunds to determine remaining returnable quantity. Per team, default OFF.
  SHOPIFY_RETURNS_BILLING_ENFORCE: featureFlagKey(
    "shopify-returns-billing-enforce",
  ), // When ON: disable the customer portal for teams past the 14-day Shopify returns billing acceptance deadline
  REDO_ASSISTED_CUSTOMS: featureFlagKey("redo-assisted-customs"), // Redo-assisted customs classification for returns: settings card + scheduled generation. Per team, default OFF.
} as const;
